import { Droplet, Flame, BookOpen, HeartHandshake, Sparkles, CalendarCheck, Gift, Compass, Gauge, Sunrise, HandHelping, Handshake, BadgeCheck, Eye, Sprout, Star, MessageCircle, Heart, PartyPopper } from "lucide-react";

export const BADGE_ICONS = {
  "calendar-check": CalendarCheck,
  flame: Flame,
  "heart-handshake": HeartHandshake,
  gift: Gift,
  compass: Compass,
  gauge: Gauge,
  sunrise: Sunrise,
  "hand-helping": HandHelping,
  "book-open": BookOpen,
  handshake: Handshake,
  sparkles: Sparkles,
  "badge-check": BadgeCheck,
  droplet: Droplet,
};

// Intentional encouragements — not likes. Each opens a written / voice / video response.
export const ENCOURAGEMENTS = [
  { kind: "i_see_you", label: "I see you", prompt: "I see you…", icon: Eye },
  { kind: "i_noticed", label: "I noticed", prompt: "What stood out to me was…", icon: Sprout },
  { kind: "i_admire", label: "I admire", prompt: "Something I admire about this…", icon: Star },
  { kind: "im_praying", label: "I'm praying", prompt: "I'm praying specifically that…", icon: HandHelping },
  { kind: "reminded_me", label: "This reminded me", prompt: "This reminded me…", icon: MessageCircle },
  { kind: "god_doing", label: "God may be doing", prompt: "What I believe God may be doing…", icon: Sparkles },
  { kind: "thank_you", label: "Thank you", prompt: "Thank you for trusting us with this…", icon: Heart },
  { kind: "celebrate", label: "Let's celebrate", prompt: "This is worth celebrating…", icon: PartyPopper },
];

export const ENCOURAGEMENT_MAP = Object.fromEntries(ENCOURAGEMENTS.map((e) => [e.kind, e]));
